import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

@Component({
  selector: 'ml-mdm-apple-application-list-item-ui',
  templateUrl: './apple-application-list-item.component.html',
  styleUrls: ['./apple-application-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, ReactiveFormsModule],
})
export class AppleApplicationListItemComponent {
  public versions: string[] = [];
  public selectedApplication: AppleApplication | null = null;

  readonly applicationVersions = input<AppleApplication[]>([]);
  readonly hideVersionSelector = input(false);
  readonly selectedApplicationChange = output<AppleApplication | null>();

  constructor() {
    effect(() => {
      const applicationVersions = this.applicationVersions();
      if (applicationVersions?.length === 0) {
        this.versions = [];
        this.selectedApplication = null;
      } else {
        this.versions = applicationVersions.map((app) => this.versionString(app));
        this.selectVersion(this.versions[0]);
      }
    });
  }

  public selectVersion(version: string): void {
    this.selectedApplication = this.applicationVersions().find((app) => this.versionString(app) === version) ?? null;
    this.selectedApplicationChange.emit(this.selectedApplication);
  }

  private versionString(app: AppleApplication) {
    const version: string = [app.shortVersionString, `(${app.bundleVersion})`].join(' ');
    return version;
  }
}
